
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[seoArticle]",
      function () {
        return require("private-next-pages/[seoArticle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[seoArticle]"])
      });
    }
  